import * as types from '../actions/actionTypes'

export function isPeriodicPaymentSelector(itemEntry) {
  return itemEntry.item?.is_periodic_payment
}

export function isDiscountEnabledSelector(itemEntry) {
  return itemEntry.item?.is_discount_enabled
}

export function isDiscountOnlySelector(itemEntry) {
  return itemEntry.item?.is_discount_only
}

export function onlyAllowMemberSelector(itemEntry) {
  return itemEntry.item?.access_policies?.includes('aifian_member')
}

export function shortURLSelector(itemEntry) {
  return itemEntry.item?.short_url ?? ''
}

// item: {
//   title: '團購名稱',
//   description: '商品描述', // 商品描述
//   image: 'https://xxx/snapshot.png', // 商品圖片 (若未設定則無此欄位)
//   price: 2000, // 商品金額 (台幣)
//   instalment: 6, // 分期期數
//   instalment_amount: 333, // 分期金額 (台幣/一期)，若無分期則為0
//   payment_amount: 335, // 不分期/首期應付金額 (台幣)
//   available: 19, // 剩餘商品數量 (若無商品數量限制則為null)
//   contact: '+886912345678', // 賣家手機號碼
//   deadline: '2020-07-14T03:41:04.000Z', // 購買截止日期 (沒有則為NULL)
//   status: 'expired', // created (開放中); terminated (已停止收款); filled (已額滿); expired (已結束)
//   exchange_rate: 31, // 台幣兌美元匯率
//   is_discount_enabled: false, // 是否可使用回饋折抵
//   is_discount_only: true, // 是否只限只用折抵
//   is_periodic_payment: false, // 是否為定期定額扣款之商品
//   is_active: true, // 目前是否開放開團/付款
//   short_url: 'https://s.aifi.me/xxx', // 商品短網址
//   logo_url: 'https://xxx/', // 賣家Logo
//   referral: {
//     // 付款完成頁面的導流連結 (若不需顯示則無此欄位)
//     title: '去Slash社團逛逛',
//     url: 'https://www.facebook.com/groups/266672091206267/',
//   },
//   vendor: {
//     // 合作廠商資訊 (若為一般賣家則無此欄位)
//     name: 'aifian', // 合作廠商別名或營業登記名稱
//   },
//   access_policies: [
//     // 可進入購買程序之交集條件 (若無限制條件則無此欄位)
//     'aifian_member',
//     'aifi_owner',
//   ],
// }

// instalmentInfo: {
//   'order_number': 'CAO0000008724',  // 訂單編號
//   'title': '團購名稱',
//   'price': 2000,              // 商品金額 (台幣)
//   'mobile': '0933123456',     // 買家手機號碼，讓買家登入時驗證是否為同一位買家
//   'contact': '+886912345678', // 賣家手機號碼 (for aifianBuyer-3)
//   'instalment': 6,            // 分期期數
//   'instalment_amount': 333,   // 分期金額 (台幣/一期)
//   'payment_amount': 335,      // 不分期/首期應付金額 (台幣)
//   'exchange_rate': 31,        // 台幣兌美元匯率
//   'status':'created',
//   'statuses': [
//     {
//       'period_num': 1,       // 第一期
//       'payment_amount': 335, // 分期金額
//       'status': 'success'    // success (已付款); processing (待付款); init (未付款)
//     },
//     {
//       'period_num': 2,       // 第二期
//       'payment_amount': 333,
//       'status': 'init'
//     },
//   ]
// },

// buyerPeriodic: {
//   'title': '定期定額測試',
//   'contact': '+886912345678',
//   'payment_amount': 18000,  // 應付金額 (台幣)
//   'exchange_rate': 31,      // 台幣兌美元匯率
//   'is_active': true,    // 目前是否開放開團/付款
//   'status': 'created',
//   'vendor': {'name': 'aifian'},
// }

export const initialState = {
  item: null,
  buyerInstalments: null,
  buyerPeriodic: null,
  isCurrentItemExist: true,
}

export function isCurrentItemExistSelector(itemEntry) {
  return itemEntry.isCurrentItemExist
}

export default function itemEntryReducer(itemEntry = initialState, action) {
  switch (action.type) {
    case types.GET_ITEM_ENTRY_INFO_SUCCESS:
      return {
        ...itemEntry,
        item: action.payload,
      }
    case types.GET_BUYER_PERIODIC_INFO_SUCCESS:
      return {
        ...itemEntry,
        buyerPeriodic: {
          status: 'created',
          available: null,
          ...action.payload,
        },
      }
    case types.GET_BUYER_INSTALMENTS_INFO_SUCCESS:
      return {
        ...itemEntry,
        buyerInstalments: action.payload,
      }
    case types.GET_ITEM_ENTRY_INFO_ERROR:
    case types.GET_BUYER_INSTALMENTS_INFO_ERROR:
    case types.GET_BUYER_PERIODIC_INFO_ERROR:
      return {
        ...itemEntry,
        item: null,
        isCurrentItemExist: false,
      }
    case types.GET_ITEM_ENTRY_INFO:
    case types.GET_BUYER_INSTALMENTS_INFO:
    case types.GET_BUYER_PERIODIC_INFO:
      return {
        ...itemEntry,
        item: null,
      }
    case types.CHECKOUT_TAPPAY_SUCCESS: {
      const { item } = itemEntry
      if (!item) return itemEntry
      const { available } = item
      if (available <= 0) return itemEntry
      return {
        ...itemEntry,
        item: {
          ...item,
          available: available - 1,
        },
      }
    }
    case types.TERMINATE_ITEM: {
      const { item } = itemEntry
      if (!item) return itemEntry
      return {
        ...itemEntry,
        item: {
          ...item,
          status: 'terminated',
        },
      }
    }
    default:
      return itemEntry
  }
}
